import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@app/store';
import { fetchAssetTypes, deleteAssetType } from './assetTypeSlice';
import { DataTable, DataFilter } from '@components/ui';
import type { Column } from '@components/ui/DataTable';
import { AssetTypeOutputDTO } from '@types';
import { LoadingSkeleton } from '@components/ui/LoadingSkeleton';
import { ErrorDisplay } from '@components/ui/ErrorDisplay';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const AssetTypeList = () => {
  console.log('🔄 Renderizando AssetTypeList');
  
  const dispatch = useDispatch<AppDispatch>();
  let { items, loading, error } = useSelector((state: RootState) => {
    console.log('🔍 Selector executando, loading:', state.assetType.loading);
    return state.assetType;
  });
  
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [filters, setFilters] = useState<Record<string, string>>({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const isLoadingRef = useRef(false);
  const initialLoadDoneRef = useRef(false);

  const loadData = useCallback(async (currentFilters: Record<string, string>) => {
    // Evita chamadas simultâneas
    if (isLoadingRef.current) {
      console.log('🚫 Requisição em andamento, ignorando nova chamada');
      return;
    }

    // Evita chamadas após o carregamento inicial
    if (initialLoadDoneRef.current && Object.keys(currentFilters).length === 0) {
      console.log('🚫 Ignorando chamada sem filtros após carregamento inicial');
      return;
    }

    console.log('📡 Iniciando requisição fetchAssetTypes');
    isLoadingRef.current = true;

    try {
      await dispatch(fetchAssetTypes(currentFilters));
      console.log('✅ Requisição fetchAssetTypes completada');
      setIsInitialLoad(false);
      initialLoadDoneRef.current = true;
    } catch (error) {
      console.error('❌ Erro na requisição:', error);
    } finally {
      isLoadingRef.current = false;
    }
  }, [dispatch]);

  const handleFilter = useCallback((newFilters: Record<string, string>) => {
    console.log('🔍 Novos filtros aplicados:', newFilters);
    setFilters(newFilters);
  }, []);

  // Efeito único para carregamento inicial
  useEffect(() => {
    if (!initialLoadDoneRef.current) {
      loadData({});
    }
  }, [loadData]);

  // Efeito separado para mudanças nos filtros
  useEffect(() => {
    if (initialLoadDoneRef.current && Object.keys(filters).length > 0) {
      loadData(filters);
    }
  }, [filters, loadData]);

  const handleDelete = async (id: string) => {
    console.log('🗑️ Iniciando delete do item:', id);
    try {
      await dispatch(deleteAssetType(id));
      setDeleteId(null);
      console.log('🔄 Recarregando lista após delete');
      dispatch(fetchAssetTypes(filters));
    } catch (error) {
      console.error('❌ Erro ao excluir:', error);
    }
  };

  const filterFields = [
    {
      name: 'name',
      label: 'Nome',
      type: 'text' as const,
    },
    {
      name: 'description',
      label: 'Descrição',
      type: 'text' as const,
    }
  ];

  const columns: Column<AssetTypeOutputDTO>[] = [
    {
      image:'image',
      style_image:{borderRadius:10,border:'1px solid lightgrey',background:'rgb(244, 244, 244)',width:30,height:30,objectFit:'contain'},
      key: 'name',
      header: 'Nome',
    },
    {
      key: 'description',
      header: 'Descrição',
    },
    // {
    //   key: 'data',
    //   header: 'Dados Adicionais',
    //   render: (value: AssetTypeOutputDTO['data']) => {
    //     return value?.length
    //       ? `${value.length} campo(s)`
    //       : 'Nenhum';
    //   }
    // }
  ];

  if (isInitialLoad && loading) {
    return <LoadingSkeleton />;
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* <Typography variant="h5" gutterBottom>
        Tipos de Bem
      </Typography> */}

      {error && <ErrorDisplay error={error} />}

      {/* <DataFilter
        fields={filterFields}
        onFilter={handleFilter}
        autoSubmit={true}
        debounceTime={500}
      /> */}

      <DataTable
        data={items.map((item:any)=>{
          let item2:any ={...item};
          item2.image='/tipos.svg';
          return item2;
        })}
        columns={columns}
        newFormat
        basePath="asset-types"
        onDelete={(id) => {
          console.log('🗑️ Solicitação de delete para id:', id);
          setDeleteId(id);
        }}
        hide_show
        loading={loading}
         title={'Tipos de Bem'}
        subtitle={'Lista de tipos de bens no sistema'}
        error={error}
        loadingComponent={<LoadingSkeleton title={false} filter={false} />}
      />

      <Dialog
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir este tipo de bem?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteId(null)}>Cancelar</Button>
          <Button
            onClick={() => deleteId && handleDelete(deleteId)}
            color="error"
            variant="contained"
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssetTypeList; 
